import { Switch } from "@neonumy/neonumy-ui";
import { Col, Form } from "antd5";
import { useTranslation } from "react-i18next";

export default function NotificationPreferences() {
  const { t } = useTranslation();

  return (
    <>
      <Col md={9} xs={24}>
        <Form.Item
          label={t("Receive notifications by email")}
          name="receiveNotificationsByEmail"
          valuePropName="checked"
          initialValue={true}
        >
          <Switch size="small" disabled />
        </Form.Item>
      </Col>
      <Col md={9} xs={24}>
        <Form.Item
          label={t("Receive the newsletter")}
          name="subscribedNewsletter"
          valuePropName="checked"
          initialValue={true}
        >
          <Switch size="small" disabled />
        </Form.Item>
      </Col>
    </>
  );
}
